'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagFmAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 8.88109e-06L28 0V20H0V8.88109e-06Z", fill: "#95CEF5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.4326 6.82405L14 5.76L15.5674 6.82405L15.0398 5.00453L16.5362 3.84262L14.6426 3.78214L14 2L13.3574 3.78214L11.4639 3.84262L12.9602 5.00453L12.4326 6.82405Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.4326 17.4907L14 16.4267L15.5674 17.4907L15.0398 15.6712L16.5362 14.5093L14.6426 14.4488L14 12.6667L13.3574 14.4488L11.4639 14.5093L12.9602 15.6712L12.4326 17.4907Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 11.0933L17.7659 12.1574L18.2935 10.3379L16.7972 9.17596L18.6907 9.11548L19.3333 7.33333L19.976 9.11548L21.8695 9.17596L20.3732 10.3379L20.9008 12.1574L19.3333 11.0933Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.09924 12.1574L8.66667 11.0933L10.2341 12.1574L9.70649 10.3379L11.2028 9.17596L9.30931 9.11548L8.66667 7.33333L8.02402 9.11548L6.13052 9.17596L7.62684 10.3379L7.09924 12.1574Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagFmAsset = forwardRef(FlagFmAsset);

export { VpFlagFmAsset as default };
